<script lang="ts" setup>
import type { BreadcrumbItem } from "~~/models/breadcrumb";

defineProps<{ item: BreadcrumbItem }>();
</script>

<template>
  <li class="after:ml-xs after:mr-[6px] after:inline-block after:w-[6px] after:origin-center after:rotate-50 after:content-[url(/spuntini/logo/icon-simple.svg)] last:after:content-none">
    <NuxtLinkLocale v-if="item.link" :to="`${item.link}`" class="hover:underline" active-class="active" exact-active-class="exact-active">
      {{ item.title }}
    </NuxtLinkLocale>

    <span v-if="!item.link">
      {{ item.title }}
    </span>
  </li>
</template>

<style scoped>

</style>
